<template>
	<div>
		<case-form :schema="schemaInsured" />

		<case-form :schema="schemaInsuredRelationship" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import ECEntityAddressList from "./ECEntityAddressList"

export default {
	name: "ECProposalInsureds",
	components: { CaseForm, ECEntityAddressList },
	computed: {
		schemaInsured() {
			return [
				{
					label: "Select Insured",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["company"]
					}
				},
				{
					label: "Customer Name",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "name",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "Addresses",
					// component: "entityAddress",
					componentObject: { source: ECEntityAddressList },
					dataType: "array",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0AddressId"
				},
				{
					label: "Nature of Business",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "natureOfBusiness",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Pawn Broker",
										value: "Pawn Broker"
									},
									{
										name: "Director",
										value: "Director"
									},
									{
										name: "Money Exchange",
										value: "Money Exchange"
									},
									{
										name: "Office",
										value: "Office"
									},
									{
										name: "Pawn Shop",
										value: "Pawn Shop"
									},
									{
										name: "Retail",
										value: "Retail"
									},
									{
										name: "Retail Shop",
										value: "Retail Shop"
									},
									{
										name: "Trading",
										value: "Trading"
									},
									{
										name: "Wholesale",
										value: "Wholesale"
									}
								]
							}
						}
					}
				},
				{
					label: "Underwriter Approval",
					component: "text",
					bindTo: "case.facts.underwriterApproval"
				}
			]
		},

		schemaInsuredRelationship() {
			return [
				{
					label: "Manage Relationship of Insured and Policyholder",
					component: "entityRelationship",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].relationships",
					bindTo: "case.facts.insured0RelationshipId"
				}
			]
		}
	}
}
</script>
